import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import { AlertContext } from "../../../context/AlertContext";
import { Link, Redirect } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import { AuthContext } from "../../../context/AuthContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import Spinner from "../Spinner";
import { styled } from "@mui/material/styles";
import { Navigate, useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import Barra from "../Barra";

export default function Qr(props) {
  //const classes = useStyles();
  const [band, setBand] = useState(true);
  const [data, setData] = useState(null);

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const { statusAcceso, configuracion, obtenerAcceso, obtenerConfiguracion } =
    configuracionContext;

  const toast = useRef(null);
  let navigate = useNavigate();

  useEffect(() => {
    usuarioAutenticado();
  }, [state.id]);

  useEffect(() => {
    obtenerConfiguracion();
  }, [state.id]);

  setTimeout(() => {
    if (statusAcceso === 400) {
      accesoDenegado();
    }
  }, 3000);

  const aceptarClick = async (e) => {
    e.preventDefault();

    setBand(false);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");
    myHeaders.append("Authorization", `Bearer ${configuracion.whapi}`);

    console.log(myHeaders)


    const options = {
      method: "GET",
      headers: myHeaders,
      /*
      headers: {
        accept: "application/json",
        authorization: `Bearer ${configuracion.whapi}`,
      },
      */
    };


    let response = await fetch(
      "https://gate.whapi.cloud/users/login?wakeup=true",
      options
    );


    if (response.ok) {
      const json = await response.json();
      if (json && json.status && json.status === "OK") {
        let array = json.base64.split(",");
        setData(array[1]);
      } else {
        window.location.reload();
      }
    }
  };

  const exitClick = (e) => {
    navigate(`/`);
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Accesos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  return (
    <Fragment>
      <Barra />
      <Toast ref={toast} />
      <Fragment>
        <Fragment>
          <Grid container spacing={3} style={{ margin: "3vw" }}>
            <Grid item xs={10} md={8}>
              <h1 style={{ textAlign: "center" }}>WhatsApp QR</h1>
            </Grid>

            {configuracion && configuracion.whapi && band ? (
              <Fragment>
                <Grid item xs={10} md={4} />
                <Grid item xs={10} md={4}>
                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    style={{ backgroundColor: "blue" }}
                    onClick={aceptarClick}
                  >
                    Generar
                  </Button>
                </Grid>
              </Fragment>
            ) : null}

            {configuracion && configuracion.whapi && !band && data ? (
              <Fragment>
                <Grid item xs={10} md={4} />
                <Grid item xs={10} md={4}>
                  <img src={`data:image/jpeg;base64,${data}`} />
                </Grid>

                <Grid item xs={12} md={12} />
                <Grid item xs={12} md={12} />

                <Grid item xs={10} md={4}>
                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    style={{ backgroundColor: "red" }}
                    onClick={exitClick}
                  >
                    Salir
                  </Button>
                </Grid>
              </Fragment>
            ) : null}
          </Grid>
        </Fragment>
      </Fragment>
    </Fragment>
  );
}
